/* eslint-disable eqeqeq */
import { useState, useEffect, useCallback, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import Modal from "@mui/material/Modal";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import GridOnOutlinedIcon from "@mui/icons-material/GridOnOutlined";
import ViewTimelineOutlinedIcon from "@mui/icons-material/ViewTimelineOutlined";
import Box from "@mui/material/Box";
import GCLoadingListSearch from "../../Component/Common/ReuseableComponent/GCLoadingListSearch";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

import moment from "moment";

import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import {
  fAlertToast,
  GetGitterColumns,
  GetAccountPostingDetail,
  GetLinkDocument,
  fcovertToNumber,
} from "../../Utility/Utilitys";
import { LoadingReceipt } from "../../Redux/roStore";
import { fExecuteAPI } from "../../Server/Apis";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import GCHead from "./processComponent/GCHead";
import {
  Set_bin_HeadObject_Set,
  Set_bin_HeadObject_Init,
  Set_bin_HeadObject_New_Set,
  Set_bin_HeadObject_CBM_Set,
} from "./Slicebin";
import "./bin.css";
import {
  CmpButton,
  CmpButtonKIcon,
  CmpButtonKWithIcon,
} from "../../Component/Common/ToolBox/ToolBox";
import {
  GridDataColumnsWmsSiDetail_Def,
  GridDataColumnsItemSearch_Def,
  //Headsearch start
  GridDataColumnsSearch_Def,
  sStatusArr,
  //headSearch end
  fKeyLoadingReceipt,
  ErrorMsg,
  fValidationHead_Client,
  fLoad_Grid,
  fSaveHead,
  fDisplay,
  fApproveLoadingReceipt,
  GetAttributes,
  sTrnTyp,
} from "./binAction";
// import { set } from 'date-fns/esm';
import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";
import { fCheck_Doc_Rights_001 } from "../../Utility/Utilitys";
import { FShortCutKey } from "../../Utility/Utilitys";
import GCAccountDetail from "../../Component/Common/ReuseableComponent/GCAccountDetail";
import GCMenuBtn from "../../Component/Common/ReuseableComponent/GCMenuBtn";
import GCLinkDocument from "../../Component/Common/ReuseableComponent/GCLinkDocument";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import { Bin_Delete_GETROW } from "../../Server/ApiV2";

export default function Bin() {
  const dispatch = useDispatch();

  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vRdxWmsHead = useSelector((state) => state.Slicebin.value.HeadObject);

  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const [sNavDocValue, setNavDocValue] = useState(1); // nav bar arrow input value

  const [sRoundingVal, setRoundingVal] = useState(2);
  // eslint-disable-next-line no-unused-vars
  const [sEnterKeyObj, setEnterKeyObj] = useState({
    key: "Enter",
  });

  const [sObjRights, setObjRights] = useState({
    RNew: "Y",
    RSave: "Y",
    RDelete: "Y",
    RApprove: "Y",
    RPrint: "Y",
    RReverse: "Y",
    RClone: "Y",
  });
  const [sObjectRights, setObjectRights] = useState({
    DocTyp: "",
    Save: "Y",
    Edit: "Y",
    Del: "Y",
    View: "Y",
    Appr: "Y",
    Reverse: "Y",
    Cancel: "Y",
    Print: "Y",
    Clone: "Y",
    Lvl: "",
  });
  const [sUser_Doc_Arr, setUser_Doc_Arr] = useState([]);
  const [sTransItemStockObj, setTransItemStockObj] = useState({
    RPStock: 0,
    MSP: 0,
    CostPr: 0,
    LPRate: 0,
  });
  // eslint-disable-next-line no-unused-vars
  const [sGCSeachSalesGroupSearch, setGCSeachSalesGroupSearch] = useState([]); //GCSeachSalesGroupSearch Select

  //HEAD
  const [sAttribute, setAttribute] = useState({
    Location: [],
    aisle: [],
    level: [],
    binType: [],
    binSize: [],
  });

  const [sErrorMsg, setErrorMsg] = useState(ErrorMsg);

  //DETAIL
  const [sDetailGridData, setDetailGridData] = useState([]); //DetailGridData Select

  //HEAD FUNCTION

  //FOOTER FUNCTION

  //DETAIL  FUNCTION

  //MODAL HEAD

  //Modal View
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };

  //Modal Summary
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  //Modal search

  //MODAL SEARCH

  const [sGridSearchHeadRowData, setGridSearchHeadRowData] = useState([]);
  const [sSearchModalObj, setSearchModalObj] = useState({
    Status: "ENTER",
    VocNo: "",
    PostDt: "",
    Loc: sAttribute.Location[0]?.UId ? sAttribute.Location[0]?.UId : "",
    RefNo: "",
  });

  const [sSearchModal, setSearchModal] = useState(false);
  const fSearch = async () => {
    setSearchModal(true);
    // SALESGROUPSSEARCH_GETROW -search salegroup dropdown
    document.getElementById("IdSearch")?.blur();
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: sAttribute.Location[0]?.UId,
    }));
    GetSearchValue("", "APICallLocModal", sAttribute.Location[0]?.UId);
  };

  const fCloseSearchModal = (e) => {
    setSearchModal(false);
    fClearSearchModal();
  };

  const fClearSearchModal = (e) => {
    setSearchModalObj({
      Status: "ENTER",
      VocNo: "",
      PostDt: "",
      Loc: sAttribute.Location[0].UId,
      RefNo: "",
    });
    setGridSearchHeadRowData([]);
  };

  //GCSearch
  const fTrans_Search_Grid_RowClick = (e) => {
    fDisplay(e?.row?.A_VocTyp, e?.row?.A_VocNo, dispatch, fNewDetail);
    fCloseSearchModal();
  };

  //GCSearch
  const fTrans_Search_Grid_KeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fTrans_Search_Grid_RowClick(newSelectionModel);
    }
  };

  const fonChangeStatusModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((value, index) => {
      return value == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Status: vSelectedValue,
    }));

    GetSearchValue("", "APICALLSTATUS", vSelectedValue);
  };

  const fonChangeVocNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      VocNo: event.target.value,
    }));
  };

  const fonChangeRefNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      RefNo: event.target.value,
    }));
  };

  const fOnChangeDateModel = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: "",
      }));
    } else {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: event?.$d,
      }));
    }

    let changedDate = event?.$d;
    // setSearchModalObj((obj) => ({
    //   ...obj,
    //   PostDt: !!event.target.value
    //     ? moment(event.target.value, "YYYY-MM-DD")._d
    //     : "",
    // }));
    if (new Date(event?.$d) >= new Date("01-01-1990")) {
      GetSearchValue("", "APICALLDATE", changedDate);
    }
  };

  const fonChangeLocModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.UId == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: vSelectedValue.UId,
    }));
    GetSearchValue("", "APICallLocModal", vSelectedValue.UId);
  };

  const GetSearchValue = async (e, xAPICALL, xSTATUS) => {
    if (
      e.key === "Enter" ||
      xAPICALL === "APICALLSTATUS" ||
      xAPICALL === "APICALLDATE" ||
      xAPICALL === "APICallLocModal"
    ) {
      let iPostdt =
        xAPICALL === "APICALLDATE"
          ? moment(xSTATUS).format("MM/DD/YYYY")
          : moment(sSearchModalObj.PostDt).format("MM/DD/YYYY");
      if (
        iPostdt == "Invalid date" ||
        iPostdt == null ||
        iPostdt === undefined ||
        iPostdt === ""
      ) {
        iPostdt = "01/01/1900";
      }

      let vSearchObj = {
        Status: xAPICALL === "APICALLSTATUS" ? xSTATUS : sSearchModalObj.Status,
        VocNo: sSearchModalObj.VocNo,
        VocDt: iPostdt,
        // VocDt: "01/01/1900",
        // RefVocNo: sSearchModalObj.RefNo,
        Loc: xAPICALL === "APICallLocModal" ? xSTATUS : sSearchModalObj.Loc,
        UserCd: vRdxuserInfo.UserID,
      };
      let FinalObj = fcheck_null_undefine_replace_empty(vSearchObj);
      const vSearch = await fExecuteAPI(
        "LoadingReceipt_Search_GETROW",
        FinalObj
      );
      if (vSearch.Type?.toUpperCase() === "SUCCESS") {
        let vSearchArr = vSearch?.ResultSet.map((obj, i) => ({
          ...obj,
          id: i + 1,
          // A_VocDt: moment(obj.A_VocDt).format("DD/MM/YYYY"),
        }));
        setGridSearchHeadRowData(vSearchArr);
      } else {
        fAlertToast("FAILED", vSearch?.response?.data?.Status);
      }
    }
  };

  //MODAL SEARCH END

  //MAIN BUTTON

  const fMove_First = (e) => {
    fClearErrorMsg();
    fDisplay(
      sUser_Doc_Arr[0].VocTyp,
      sUser_Doc_Arr[0].VocNo,
      dispatch,
      fNewDetail
    );
    setNavDocValue(1);
  };

  const fMove_Last = (e) => {
    fClearErrorMsg();
    fDisplay(
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].VocTyp,
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].VocNo,
      dispatch,
      fNewDetail
    );
    setNavDocValue(sUser_Doc_Arr.length);
  };

  const fMove_Previouse = (e) => {
    fClearErrorMsg();
    if (sNavDocValue > 1) {
      var row = sNavDocValue - 1;
      fDisplay(
        sUser_Doc_Arr[row - 1].VocTyp,
        sUser_Doc_Arr[row - 1].VocNo,
        dispatch,
        fNewDetail
      );
      setNavDocValue(row);
    }
  };

  const fMove_Next = (e) => {
    fClearErrorMsg();

    if (sNavDocValue < sUser_Doc_Arr.length) {
      var row = sNavDocValue + 1;
      fDisplay(
        sUser_Doc_Arr[row - 1].VocTyp,
        sUser_Doc_Arr[row - 1].VocNo,
        dispatch,
        fNewDetail
      );
      setNavDocValue(row);
    }
  };
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };
  const fPrint = useCallback(
    (xPrnTyp) => {
      let webReport = vRdxDBKernObj?.WEB_REPORT_BASE_URL;

      //http://192.168.50.243:8010/WebReports/WMS/LoadingReceipt?prntyp=WMLDLSTH_DET&voctyp=LD001&vocno=LD00083438	- Detail
      //http://192.168.50.243:8010/WebReports/WMS/LoadingReceipt?prntyp=WMLDLSTH_VAR&voctyp=LD001&vocno=LD00083438	- varience
      let PrintURl =
        webReport?.Val +
        "WMS/LoadingReceipt?prntyp=" +
        xPrnTyp +
        "&voctyp=" +
        vRdxWmsHead.A_VocTyp +
        "&vocno=" +
        vRdxWmsHead.A_VocNo;
      setWebReportUrlModal(PrintURl);
      fWebReport();
    },
    [vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp, vRdxDBKernObj]
  );

  let timeout = null;
  const fSave = async (e) => {
    clearTimeout(timeout);
    fClearErrorMsg();

    timeout = setTimeout(async () => {
      let validation = fValidationHead_Client(vRdxWmsHead, setErrorMsg);
      if (!validation && vMediaQuery) {
        fSummary();
      }
      if (!validation) return;

      if (!validation && vMediaQuery) {
        fSummary();
      }

      fSaveHead(fNewDetail);
    }, 800);
  };

  const fApprove = async (e) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (sDetailGridData.length == 0) {
        fAlertToast("INFO", "Add atleast one line item");
        return;
      }
      let validation = fValidationHead_Client(vRdxWmsHead, setErrorMsg);
      if (!validation && vMediaQuery) {
        fSummary();
      }
      if (!validation) return;

      fApproveLoadingReceipt(dispatch, fNewDetail);
    }, 800);
  };

  const fClearErrorMsg = () => {
    setErrorMsg(ErrorMsg);
  };

  const fNew = async () => {
    fClearErrorMsg();

    fNewDetail();
  };

  const fNewDetail = () => {
    dispatch(Set_bin_HeadObject_Init()); // Head Clearing
    // Setting Initial List Box 0th Object
    dispatch(
      Set_bin_HeadObject_New_Set({
        Aisle: sAttribute?.aisle[0]?.UId,
        Level: sAttribute?.level[0]?.UId,
        Loc: sAttribute?.Location[0]?.UId,
        Type: sAttribute?.binType[0]?.UId,
        BinSize: sAttribute?.binSize[0]?.UId,
      })
    );
    fLoad_Grid(setDetailGridData);
    setNavDocValue(1); // nav init 1
    document.getElementsByName("B_ItmName")[0]?.focus();
  };

  const fDelete = (e) => {
    confirmAlert({
      title: "Delete",
      message: "Are you want to delete line item.",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => {
            fDeleteDetail();
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => "",
        },
      ],
    });
  };

  // DELETESIHEAD_GETROW

  //DELETESIDETAIL_GETROW
  const fDeleteDetail = async () => {
    let vDeleteSIDetailObj = {
      v_UId: vRdxWmsHead.Code,
    };

    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIDetailObj);
    const vDeleteSIDetail = await Bin_Delete_GETROW(FinalObj);

    if (vDeleteSIDetail?.status == 200) {
      fAlertToast("SUCCESS", "Successfully Deleted Line Item");
      fNewDetail(vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp);
    }
  };

  const fDetail_Grid_onRowClick = async (item) => {
    dispatch(
      Set_bin_HeadObject_Set({
        ...vRdxWmsHead,
        Code: item.row.UId,
        Aisle: item.row.AisleCd,
        Level: item.row.BinType,
        ShortDesc: item.row.Name2,
        Desc: item.row.Name1,
        Loc: item.row.Loc,
        Length: item.row.Length,
        Width: item.row.Width,
        Height: item.row.Height,
        CBM: item.row.CBM,
        LengthWastage: item.row.LengthWastage,
        WidthWastage: item.row.WidthWastage,
        HeightWastage: item.row.HeightWastage,
        NoOfPallet: item.row.Pallet,
        Type: item.row.BinAttr1,
        BinSize: item?.row?.BNSizeCode,
      })
    );
    fCloseViewModal();
  };

  //accountDetail start
  const [sAccountDetailModal, setAccountDetailModal] = useState(false);
  const [sGridDataAccountDetailRows, setGridDataAccountDetailRows] = useState(
    []
  );
  const [sGridDataAccountDetailColumns, setGridDataAccountDetailColumns] =
    useState([
      {
        field: "id",
        headerName: "Sr.No",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcCd",
        headerName: "AcCd",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcName",
        headerName: "AcName",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "Br",
        headerName: "Br",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "BrName",
        headerName: "BrName",
        width: 130,
        headerClassName: "grid-header-row",
      },

      {
        field: "AmtLc",
        headerName: "AmtLc",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "DrCr",
        headerName: "DrCr",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr",
        headerName: "Narr",
        width: 200,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr1",
        headerName: "Narr1",
        width: 200,
        headerClassName: "grid-header-row",
      },
    ]);
  const fOpenAccountDetailModal = () => {
    setAccountDetailModal(true);
  };
  const fAccountDetail = async (e) => {
    const { HeadObject } = LoadingReceipt();
    await GetAccountPostingDetail(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      setGridDataAccountDetailRows
    );

    fOpenAccountDetailModal();
  };
  const fCloseAccountDetailModal = (e) => {
    setAccountDetailModal(false);
  };
  //accountDetail end

  //fLinkDocument start
  const [sLinkDocumentModal, setLinkDocumentModal] = useState(false);
  const [sGridDataLinkDocumentRows, setGridDataLinkDocumentRows] = useState([]);
  const [sGridDataLinkDocumentColumns, setGridDataLinkDocumentColumns] =
    useState([
      {
        field: "A_VocTyp",
        headerName: "Doc.Type",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "VocName",
        headerName: "Doc.Name",
        hide: false,
        width: 180,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_VocNo",
        headerName: "Doc.No",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_DocStat",
        headerName: "Status",
        hide: false,
        width: 50,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "id",
        headerName: "id",
        hide: false,
        width: 40,
        align: "left",
        headerAlign: "left",
      },
    ]);
  const fOpenLinkDocumentModal = () => {
    setLinkDocumentModal(true);
  };
  const fLinkDocument = async (e) => {
    const { HeadObject } = LoadingReceipt();
    await GetLinkDocument(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      sTrnTyp,
      setGridDataLinkDocumentRows
    );

    fOpenLinkDocumentModal();
  };
  const fCloseLinkDocumentModal = (e) => {
    setLinkDocumentModal(false);
  };
  //LinkDocument end

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onload = useCallback(async () => {
    if (vRdxDBKernObj.DIGIT_ROUNDING) {
      setRoundingVal(Number(vRdxDBKernObj.DIGIT_ROUNDING?.Val));
    }
    let iAttributeResp = await GetAttributes(setAttribute);

    dispatch(
      Set_bin_HeadObject_Set({
        ...vRdxWmsHead,
        Aisle:
          vRdxWmsHead?.Aisle == "" ||
          vRdxWmsHead?.Aisle == null ||
          vRdxWmsHead?.Aisle == undefined
            ? iAttributeResp?.aisle[0]?.UId
            : vRdxWmsHead.Aisle,
        Level:
          vRdxWmsHead?.Level == "" ||
          vRdxWmsHead?.Level == null ||
          vRdxWmsHead?.Level == undefined
            ? iAttributeResp?.level[0]?.UId
            : vRdxWmsHead.Level,
        Loc:
          vRdxWmsHead.Loc == "" ||
          vRdxWmsHead?.Loc == null ||
          vRdxWmsHead?.Loc == undefined
            ? iAttributeResp?.Location[0]?.UId
            : vRdxWmsHead.Loc,
        Type:
          vRdxWmsHead.Type == "" ||
          vRdxWmsHead?.Type == null ||
          vRdxWmsHead?.Type == undefined
            ? iAttributeResp?.binType[0]?.UId
            : vRdxWmsHead.Type,
      })
    );

    fLoad_Grid(setDetailGridData);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    var resultObj = fCheck_Doc_Rights_001(
      vRdxWmsHead.A_DocStat,
      vRdxWmsHead.A_VocTyp,
      !!sObjectRights && sObjectRights.length > 0 ? sObjectRights : []
    );
    setObjRights(resultObj);
  }, [vRdxWmsHead.A_DocStat, vRdxWmsHead.A_VocTyp, sObjectRights]);

  // CLICK ANY WHERE AND CLOSE IF TOGGLE IS CLOSED

  const fkeyup = useCallback((e) => {
    if (e.key === "Enter") {
      let lastChild = document?.getElementById("binContent");

      let TagArr = !!lastChild
        ? lastChild?.querySelectorAll(".lastkeyDetect")
        : "";
      let ilengthz = !!TagArr ? TagArr?.length : "";

      if (!!ilengthz) {
        if (
          TagArr[ilengthz - 1]?.getElementsByTagName("input")[0]?.name ==
            e.target.name &&
          document?.getElementById("WMSDocStatID")?.innerHTML == "ENTER"
        ) {
          confirmAlert({
            title: "Save",
            message: "Are you want to Save.",
            buttons: [
              {
                className: "alertBtn",
                name: "SaveYes",
                label: "Yes",
                onClick: () => {
                  document.getElementById("IdSave")?.click();
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => "",
              },
            ],
          });
        }
      }
    }
  }, []);

  useEffect(() => {
    onload();
  }, [onload]);

  useEffect(() => {
    document.addEventListener("keyup", (e) => fkeyup(e), false);
    return () => {
      document.removeEventListener("keyup", fkeyup, false);
    };
  }, [fkeyup]);

  const fkeyup2 = useCallback(
    (e) => {
      let vRdxPrint = "WMLDLSTH_DET";
      FShortCutKey(
        e,
        "IdNew",
        "IdSave",
        "IdApprove",
        "IdSearch",
        "IdDelete",
        "IdAudit",
        vRdxPrint,
        fPrint
      );
    },
    [fPrint]
  );

  useLayoutEffect(() => {
    window.addEventListener("keyup", fkeyup2);

    return () => {
      window.removeEventListener("keyup", fkeyup2);
    };
  }, [fkeyup2]);

  useLayoutEffect(() => {
    let Height =
      fcovertToNumber(vRdxWmsHead.Height) -
      fcovertToNumber(vRdxWmsHead.HeightWastage);
    let Width =
      fcovertToNumber(vRdxWmsHead.Width) -
      fcovertToNumber(vRdxWmsHead.WidthWastage);
    let Length =
      fcovertToNumber(vRdxWmsHead.Length) -
      fcovertToNumber(vRdxWmsHead.LengthWastage);
    let iCBM =
      fcovertToNumber(Height) *
      fcovertToNumber(Width) *
      fcovertToNumber(Length);
    dispatch(
      Set_bin_HeadObject_CBM_Set({
        CBM: iCBM / 1000000,
      })
    );
  }, [vRdxWmsHead.Length, vRdxWmsHead.Width, vRdxWmsHead.Height]);

  const [GridDataColumnsWmsSiDetail, setGridDataColumnsWmsSiDetail] = useState(
    GridDataColumnsWmsSiDetail_Def
  );
  const [GridDataColumnsItemSearch, setGridDataColumnsItemSearch] = useState(
    GridDataColumnsItemSearch_Def
  );
  const [GridDataColumnsSearch, setGridDataColumnsSearch] = useState(
    GridDataColumnsSearch_Def
  );

  useEffect(() => {
    // GetGitterColumns(
    //   setGridDataColumnsWmsSiDetail,
    //   "LOADINGRECEIPT_DETAIL",
    //   GridDataColumnsWmsSiDetail
    // );
    GetGitterColumns(
      setGridDataColumnsItemSearch,
      "LOADINGRECEIPT_ITEM_SEARCH",
      GridDataColumnsItemSearch
    );
    GetGitterColumns(
      setGridDataColumnsSearch,
      "LOADINGRECEIPT_SEARCH",
      GridDataColumnsSearch
    );
    GetGitterColumns(
      setGridDataAccountDetailColumns,
      "ACPSTINGDTLTRNS",
      sGridDataAccountDetailColumns
    );
    GetGitterColumns(
      setGridDataLinkDocumentColumns,
      "WMINV08LINKDDOC",
      sGridDataLinkDocumentColumns
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="container-fluid">
      <div
        style={{
          position: "fixed",
          top: 45,
          left: 2,
          width: "100%",
          backgroundColor: "white",
          zIndex: 2,
        }}
      >
        <div>
          {/* mobile Screen nav  */}
          <Grid
            container
            spacing={0}
            className="my-2 Wms-inbound-grn-nav-md-hide"
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            sx={{ alignItems: "center" }}
          >
            <Grid
              item
              xs={3}
              sm={1}
              md={1}
              lg={1}
              sx={{ justifyContent: "center", textAlign: "center" }}
            >
              {/* <CmpButton
                  xbtnName="New"
                  xOnClick={(e) => fNew()}
                  xVariant="text"
                  xDisabled={sObjRights.RNew == "N"}
                  xSize="small"
                  xjustifyContent="flex-start"
                  xSendIcon={<AddBoxRoundedIcon />}
                /> */}
              <CmpButtonKWithIcon
                xOnClick={fNew}
                xDisabled={sObjRights.RNew == "N"}
                xIcon={<AddBoxRoundedIcon fontSize={"small"} />}
              />
            </Grid>
            <Grid
              item
              xs={3}
              sm={1}
              md={1}
              lg={1}
              sx={{ justifyContent: "center", textAlign: "center" }}
            >
              {/* <CmpButton
                  xbtnName="Save"
                  xOnClick={fSave}
                  xVariant="text"
                  xDisabled={sObjRights.RSave == "N"}
                  xSize="small"
                  xjustifyContent="flex-start"
                  xSendIcon={<SaveRoundedIcon />}
                /> */}
              <CmpButtonKWithIcon
                xOnClick={fSave}
                xDisabled={sObjRights.RSave == "N"}
                xIcon={<SaveRoundedIcon fontSize={"small"} />}
                xcolor="success"
              />
            </Grid>

            {/* <Grid
                item
                xs={2.4}
                sm={1}
                md={1}
                lg={1}
                sx={{ justifyContent: "center", textAlign: "center" }}
              >
                
                <CmpButtonKWithIcon
                  xOnClick={fApprove}
                  xDisabled={sObjRights.RApprove == "N"}
                  xIcon={<CheckCircleOutlineRoundedIcon fontSize={"small"} />}
                />
              </Grid> */}
            {/* <Grid
                item
                xs={2.4}
                sm={1}
                md={1}
                lg={1}
                sx={{ justifyContent: "center", textAlign: "center" }}
              >
              
                <CmpButtonKWithIcon
                  xOnClick={() => {
                    fSearch();
                  }}
                  xDisabled={false}
                  xIcon={<SearchRoundedIcon fontSize={"small"} />}
                />
              </Grid> */}
            <Grid
              item
              xs={3}
              sm={1}
              md={1}
              lg={1}
              sx={{ justifyContent: "center", textAlign: "center" }}
            >
              <CmpButtonKWithIcon
                xOnClick={() => {
                  fView();
                }}
                xDisabled={false}
                xIcon={<ViewTimelineOutlinedIcon fontSize={"small"} />}
              />
            </Grid>
            <Grid
              item
              xs={3}
              sm={1}
              md={1}
              lg={1}
              sx={{ justifyContent: "center", textAlign: "center" }}
            >
              <CmpButtonKWithIcon
                xOnClick={fDelete}
                xDisabled={
                  vRdxWmsHead.A_DocStat == "ENTER"
                    ? false
                    : sObjRights.RDelete == "N"
                    ? true
                    : false
                }
                xIcon={<DeleteRoundedIcon fontSize={"small"} />}
                xcolor="error"
              />
            </Grid>
            <Grid
              item
              xs={4}
              sm={1}
              md={1}
              lg={1}
              className="xs-dontShowInMobileView"
            >
              {/* <CmpButton
                  xbtnName="View"
                  xOnClick={fView}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xjustifyContent="flex-start"
                  xSendIcon={<ViewTimelineOutlinedIcon />}
                /> */}
            </Grid>

            <Grid
              item
              xs={4}
              sm={1}
              md={1}
              lg={1}
              className="xs-dontShowInMobileView"
            >
              {/* <CmpButton
                  xbtnName="Summary"
                  xOnClick={fSummary}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xjustifyContent="flex-start"
                  xSendIcon={<GridOnOutlinedIcon />}
                /> */}
            </Grid>
          </Grid>
        </div>
      </div>
      <div className="row" style={{ padding: "0px" }}>
        <div className="col-12" style={{ padding: "0px" }}>
          <div className="Wms-outbound-grv">
            <Grid
              container
              spacing={0}
              className="my-2 Wms-inbound-grn-nav-sm-hide"
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              sx={{ alignItems: "center" }}
            >
              <Grid item xs={1} sm={2} md={1} lg={1}>
                <CmpButton
                  xbtnName="New"
                  xOnClick={(e) => fNew(0)}
                  xVariant="text"
                  xDisabled={sObjRights.RNew == "N"}
                  xSize="small"
                  xId={"IdNew"}
                  xSendIcon={<AddBoxRoundedIcon />}
                />
              </Grid>
              <Grid item xs={1} sm={2.5} md={1} lg={1}>
                <CmpButton
                  xbtnName="Save"
                  xOnClick={fSave}
                  xVariant="text"
                  xDisabled={sObjRights.RSave == "N"}
                  xSize="small"
                  xId={"IdSave"}
                  xSendIcon={<SaveRoundedIcon />}
                />
              </Grid>
              {/* <Grid item xs={1} sm={2.5} md={1} lg={1}>
                <CmpButton
                  xbtnName="Approve"
                  xOnClick={fApprove}
                  xVariant="text"
                  xDisabled={sObjRights.RApprove == "N"}
                  xSize="small"
                  xId={"IdApprove"}
                  xSendIcon={<CheckCircleOutlineRoundedIcon />}
                />
              </Grid> */}
              {/* <Grid item xs={1} sm={2.5} md={1} lg={1}>
                <CmpButton
                  xbtnName="Search"
                  xOnClick={fSearch}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xId={"IdSearch"}
                  xSendIcon={<SearchRoundedIcon />}
                />
              </Grid> */}
              <Grid item xs={1} sm={2.5} md={1} lg={1}>
                <CmpButton
                  xbtnName="Delete"
                  xOnClick={fDelete}
                  xVariant="text"
                  xDisabled={
                    //  sObjRights.RDelete == "N"
                    //   ? true:
                    false
                  }
                  xSize="small"
                  xId="IdDelete"
                  xSendIcon={<DeleteRoundedIcon />}
                />
              </Grid>
              {/* <Grid item xs={1} sm={2} md={0.5} lg={0.5}>
                <CmpButtonKIcon
                  xOnClick={fMove_First}
                  xDisabled={false}
                  xIcon={<FirstPageIcon fontSize={"small"} />}
                />
              </Grid> */}
              {/* <Grid
                item
                xs={1}
                sm={2}
                md={0.5}
                lg={0.5}
                className="text-center"
              >
                <CmpButtonKIcon
                  xOnClick={fMove_Previouse}
                  xDisabled={false}
                  xIcon={<ArrowBackIosIcon fontSize={"small"} />}
                />
              </Grid> */}
              {/* <Grid item xs={1} sm={4} md={1} lg={1} className="text-center">
                {sNavDocValue} of {sUser_Doc_Arr.length}
              </Grid> */}
              {/* <Grid
                item
                xs={1}
                sm={2}
                md={0.5}
                lg={0.5}
                className="text-center"
              >
                <CmpButtonKIcon
                  xOnClick={fMove_Next}
                  xDisabled={false}
                  xIcon={<ArrowForwardIosIcon fontSize={"small"} />}
                />
              </Grid> */}
              {/* <Grid
                item
                xs={1}
                sm={2}
                md={0.5}
                lg={0.5}
                className="text-center"
              >
                <CmpButtonKIcon
                  xOnClick={fMove_Last}
                  xDisabled={false}
                  xIcon={<LastPageIcon fontSize={"small"} />}
                />
              </Grid> */}
              {/* <Grid item xs={1} sm={2} md={1} lg={1}>
                <DropdownButton
                  id="dropdown-basic-button"
                  title="Print"
                  variant="outlined"
                  size="sm"
                  disabled={sObjRights.RPrint == "N" ? true : false}
                >
                  <Dropdown.Item
                    onClick={(e) => {
                      fPrint("WMLDLSTH_DET");
                    }}
                  >
                    Details
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={(e) => {
                      fPrint("WMLDLSTH_VAR");
                    }}
                  >
                    Variance
                  </Dropdown.Item>
                </DropdownButton>
              </Grid> */}
              {/* <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                <CmpButton
                  xbtnName="Account Detail"
                  xOnClick={fAccountDetail}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xSendIcon={<AccountBalanceOutlinedIcon />}
                />
              </Grid> */}
              {/* <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                <GCMenuBtn
                  menuLabel="More"
                  menuItems={[
                    { label: "Account Detail", onClick: fAccountDetail },
                    // { label: "Link Document", onClick: fLinkDocument },
                  ]}
                />
              </Grid> */}
            </Grid>

            <>
              <div id="wms-salese-invoice-id">
                <div className=" wms-incoice-sales-m main-wms-sales-invoice-hide-sm main-wms-sales-invoice-show-sm ">
                  <GCHead
                    xErrorMsg={sErrorMsg}
                    xKey={fKeyLoadingReceipt}
                    vRdxWmsHead={vRdxWmsHead}
                    sAttribute={sAttribute}
                  />
                </div>
                <div className="wms-sales-Content wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                  <div className="wms-sales-content-grid xs-screen-hide">
                    <div style={{ height: "60vh", width: "100%" }}>
                      <DataGrid
                        rowHeight={30}
                        headerHeight={40}
                        getRowClassName={(params) =>
                          params.indexRelativeToCurrentPage % 2 === 0
                            ? "mui-even-row"
                            : "mui-odd-row"
                        }
                        sx={{
                          border: 1,
                          borderColor: "primary.light",
                        }}
                        rows={sDetailGridData}
                        columns={GridDataColumnsWmsSiDetail}
                        onRowClick={fDetail_Grid_onRowClick}
                        hideFooter={sDetailGridData.length < 100}
                        components={{
                          Toolbar: vMediaQuery ? "" : GridToolbar,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>
        </div>
      </div>

      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"View"} onClose={fCloseViewModal} />
          <div className="py-2">
            <div style={{ height: "70vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sDetailGridData}
                columns={GridDataColumnsWmsSiDetail}
                onRowClick={fDetail_Grid_onRowClick}
                hideFooter={sDetailGridData.length < 100}
                components={{
                  Toolbar: vMediaQuery ? "" : GridToolbar,
                }}
              />
            </div>
          </div>
        </Box>
      </Modal>

      {/* Search  */}
      <GCLoadingListSearch
        open={sSearchModal}
        xStatusArr={sStatusArr}
        xLocationArr={sAttribute.Location}
        fonChangeStatusModal={fonChangeStatusModal}
        fonChangeVocNoModal={fonChangeVocNoModal}
        fOnChangeDateModel={fOnChangeDateModel}
        fonChangeLocModal={fonChangeLocModal}
        fonChangeRefNoModal={fonChangeRefNoModal}
        xGetSearchValue={GetSearchValue}
        fCloseSearchModal={fCloseSearchModal}
        fClearSearchModal={fClearSearchModal}
        GridSearchHeadRowData={sGridSearchHeadRowData}
        GridDataColumnsSearch={GridDataColumnsSearch}
        xOnCellKeyDownSearch={fTrans_Search_Grid_KeyDown}
        xOnRowClickSearch={fTrans_Search_Grid_RowClick}
        vMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
        xTitle={"Loading Receipt - Search"}
        xStatusVal={sSearchModalObj.Status}
        xVocNoVal={sSearchModalObj.VocNo}
        xPostDtVal={sSearchModalObj.PostDt}
        xLocVal={sSearchModalObj.Loc}
        xRefNoVal={sSearchModalObj.RefNo}
      />
      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
      <GCAccountDetail
        xOpen={sAccountDetailModal}
        fCloseDetailModal={fCloseAccountDetailModal}
        GridDataAccountDetailColumns={sGridDataAccountDetailColumns}
        GridDataAccountDetailRows={sGridDataAccountDetailRows}
        xTitle={"Account Detail"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />

      <GCLinkDocument
        xOpen={sLinkDocumentModal}
        fCloseDetailModal={fCloseLinkDocumentModal}
        GridDataLinkDocumentColumns={sGridDataLinkDocumentColumns}
        GridDataLinkDocumentRows={sGridDataLinkDocumentRows}
        xTitle={"Link Document"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />
    </div>
  );
}
